import React, { Fragment } from "react"

import { UtilityService } from "../../services"

import productPic from "../../assets/images/no-product-image.png"

function ImageTopLeft(props) {
  const { index, noRemove, type } = props
  return (
    <div className={type === "type2" ? "upload-photo-2" : "upload-photo"}>
      <img
        src={
          typeof props.image == "object"
            ? window.URL.createObjectURL(props.image)
            : props.image != ""
              ? UtilityService.fileUrl() + props.image
              : productPic
        }
        onClick={() => props.image && props.modalData(props.image)}
      />
      {!props.disabled && props.image == "" && (
        <a class="btn-floating btn-small waves-effect waves-light black btn-img-upload">
          <i class="material-icons input-file-i">add</i>
        </a>
      )}
      {!props.disabled && props.image !== "" && (
        <span className="positioing-section">
          <span className="pull-right p-1 edit">
            <input
              type="file"
              className="fileInputs"
              onChange={e => props.fileUpload(e.target.files)}
            />
            <i className="fa fa-edit icon-fa-color print-hidden"></i>
          </span>
          {props.noRemove == undefined && (
            <span className="pull-right p-1 delete">
              <i
                className="fa fa-trash icon-fa-color print-hidden"
                onClick={e => props.removeImage(e)}
              ></i>
            </span>
          )}
        </span>
      )}
      {!props.disabled && props.image == "" && (
        <input
          type="file"
          accept="image/*"
          className="input-file"
          name="profilePicture"
          style={{ display: "none" }}
          onChange={e => props.fileUpload(e.target.files)}
        />
      )}
    </div>
  )
}

export default ImageTopLeft


// WEBPACK FOOTER //
// ./src/components/ImageTopLeft/index.js